import { useElitePlansLanding } from '../../ElitePlansLandingContext'
import { isEliteAdviceCard, resolveAdviceCardIconSrc } from './adviceCardIcons'

/** Plan-colored advice icon; lock comes from landing provider, except Elite cards stay unlocked for Elite users. */
export function AdviceCardPlanIcon({ cardId }: { cardId: string }) {
  const { selectedPlanId, showAdviceCardLock, eliteInsights } = useElitePlansLanding()
  // Elite members already own Elite cards, so they stay unlocked on the Elite Prime tab too
  const locked = showAdviceCardLock && !(isEliteAdviceCard(cardId) && Boolean(eliteInsights?.userElite))
  const iconSrc = resolveAdviceCardIconSrc(cardId, selectedPlanId, locked)
  if (!iconSrc) return null

  // Fixed 28px box so 26px unlocked and 28px locked assets keep the glyph in the same spot
  return (
    <span className='inline-flex size-7 shrink-0' aria-hidden='true'>
      <img src={iconSrc} alt='' className='max-h-full max-w-full object-contain' />
    </span>
  )
}
